import { useLanguage } from "@/i18n/LanguageContext";

// Arabic word masar as rhythmic accent glyph
const AR = "مسار";

// Slow editorial marquee. One line. Repeats gracefully.
export default function EditorialMarquee({ id = "" }) {
  const { t } = useLanguage();
  const phrases = ["MASAR", ...t("marquee.phrases"), "masar.ltd"];
  const items = [];
  for (let k = 0; k < 3; k += 1) {
    phrases.forEach((p, i) => items.push({ text: p, key: `${k}-${i}` }));
  }
  return (
    <section
      id={id}
      data-testid="masar-marquee"
      aria-hidden="true"
      className="relative border-y border-neutral-900 py-6 sm:py-10 overflow-hidden bg-black"
    >
      <div className="flex w-max mq-track gap-14 whitespace-nowrap">
        {items.map((it) => (
          <span
            key={it.key}
            className="inline-flex items-center gap-14 font-serif-italic text-3xl sm:text-5xl lg:text-6xl text-neutral-200 leading-none"
          >
            {it.text}
            <span className="text-[#FF6A1A] not-italic text-2xl sm:text-3xl">
              ✦
            </span>
            <span dir="rtl" lang="ar" className="text-neutral-500 italic">
              {AR}
            </span>
          </span>
        ))}
      </div>
    </section>
  );
}
